<body>
    <div>
        <div class="center-container">
            <div class="content-area">
                <!-- Stepper - Sidebar -->
                <div class="sidebar">
                    <div *ngIf="isEditMode" class="role-title">Editing {{ scenario_name }}</div> 
                    <app-stepper [isEditMode]="isEditMode" (changeStepperEvent)="changeStepper($event)"></app-stepper>
                </div>
                <!-- Form Elements-->
                <div class="container">
                    <div class="summary-section">
                        <div>
                            <label class="labels" for="summary">Roleplay Summary</label>
                        </div>
                        <div *ngIf="isLoading" class="loader-container">
                            <div class="loader"></div>
                            <p id="loader-message">Loading summary... Please wait...</p>
                        </div>
                        <textarea id="summary" rows="5" class="sum-text" [(ngModel)]="summary"
                            style="width: 97%; padding: 5px; height: 200px;" placeholder="Edit your summary here..."
                            [disabled]="true">
                            </textarea>
                    </div>
                    <div class="inner-container">
                        <form [formGroup]="step6Form" (ngSubmit)="next()" class="form6">

                            <div class="">
                                <div>
                                    <label class="labels" for="summary">Additional Summary</label>
                                </div>
                                <textarea id="additional_summary" rows="3" formControlName="additional_summary"
                                    style="width: 97%; padding: 5px; height: 100px; background-color: white;"
                                    placeholder="Add additional summary here...">
                                    </textarea>
                            </div>
                            <div class="top-block">
                                <div class="cust row-1">
                                    <label class="labels" for="customerName">Scenario Name<span
                                            style="color:#F30617;margin:2px">*</span>:</label>
                                    <input style="width: 80%;
                                        height: 29px;
                                        margin-top: -4px;
                                        margin-bottom: -3px;
                                        background: #FFFFFF 0% 0% no-repeat padding-box;
                                        border: 1px solid #E9E9E9;
                                        border-radius: 8px;
                                        opacity: 1;
                                        padding-left: 5px;
                                        font-size: 12px;margin-left: 10px;" type="text" formControlName="customerName"
                                        id="customerName" placeholder="Enter Scenario name"
                                        (input)="ScenarioName($event)">
                                </div>
                                <div class="required-txt"
                                    *ngIf="step6Form.get('customerName')?.errors?.['required'] && step6Form.get('customerName')?.touched">
                                    Scenario name is required.
                                </div>
                                <div class="required-txt"
                                    *ngIf="step6Form.get('customerName')?.errors?.['onlyNumbers']">
                                    Scenario name can't be only numbers.
                                </div>
                                <div class="required-txt"
                                    *ngIf="step6Form.get('customerName')?.errors?.['onlySpecials']">
                                    Scenario name can't be only special characters.
                                </div>
                                <div class="required-txt" *ngIf="step6Form.get('customerName')?.errors?.['noAlphabet']">
                                    Scenario name must contain at least one alphabet.
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
                <div class="cancel-button" (click)="goBackMain()">&times;</div>
            </div>
        </div>
        <div *ngIf="isPopupVisible" id="myPopup" class="popup">
            <div class="popup-content">
                <h1 style="color: green">
                    Congratulations!
                </h1>
                <p>You have successfully {{createUpdateText}} roleplay scenario!</p>
                <button id="closePopup" (click)="closePopup()">
                    Ok
                </button>
            </div>
        </div>
        <div class="footer-step1 footer-step-two-col">
            <div class="secondary-button" (click)="goBack()" *ngIf="this.isScenarioVisible">
                <div>Previous</div>
            </div>
            <div class="secondary-button" (click)="goBackScenario()" *ngIf="!this.isScenarioVisible">
                <div>Previous</div>
            </div>
            <div>
                <button class="primary-button btn-submit" id="nextButton" (click)="next()">
                    {{isEditMode? 'Save' : 'Submit'}}
                </button>
            </div>
        </div>
    </div>
</body>